import { create } from 'zustand';
import { MenuDto } from 'src/dtos/menu/menuDto';

export interface SubMenu {
  id: number;
  title: string;
}

export interface MenuItem {
  id: number;
  title: string;
  subMenuList: SubMenu[];
}

export interface MenuStore {
  menuList: MenuDto[];
  setMenuList: (menuList: MenuDto[]) => void;
}

// export const excludeMenu = ['PUR', 'PRD', 'EQM', 'TQC', 'WMS', 'TMP'];
// export const visibleSecondMenu = ['SAL20', 'MST10', 'MST20', 'SYS10', 'SYS40', 'SYS30']
// export const visibleThirdMenu = ['SAL2020_R01', 'MST1010_R01', 'MST2010_R01', 'SYS1010_R01', 'SYS4010_R01', 'SYS3050_R01']
export const defaultMenu = 'FIXED_TAB';

// Zustand 스토어 생성
const useMenuStore = create<MenuStore>((set) => ({
  menuList: [],
  setMenuList: (menuList: MenuDto[]) => set((state) => {
    return {
      ...state,
      menuList
    }
  }),
}));

export default useMenuStore;